export const en = {
    b: 'B',
    kb: 'KB',
    mb: 'MB',
    gb: 'GB',
    tb: 'TB',
};
